import { render, staticRenderFns } from "./ClinicDashboardHome.vue?vue&type=template&id=0a94d9b6&"
import script from "./ClinicDashboardHome.vue?vue&type=script&lang=js&"
export * from "./ClinicDashboardHome.vue?vue&type=script&lang=js&"
import style0 from "./ClinicDashboardHome.vue?vue&type=style&index=0&id=0a94d9b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports